import {
  GET_ALERTS,
  GET_NOT_READ_ALERTS,
  PATCH_OR_DELETE_ALERT
} from "resources/ApiUrls"
import MyAxiosInstance from "utils/MyAxiosInstance"

const get = (centerId, page, size) => MyAxiosInstance.get(GET_ALERTS(centerId, page, size))

const getUnread = (centerId) => MyAxiosInstance.get(GET_NOT_READ_ALERTS(centerId))

const update = (alertId, body) => MyAxiosInstance.patch(PATCH_OR_DELETE_ALERT(alertId), body)

const remove = (alertId) => MyAxiosInstance.delete(PATCH_OR_DELETE_ALERT(alertId))

const alertsAPICalls = { get, getUnread, remove, update }

export default alertsAPICalls